import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewChildren } from '@angular/core';
import { ArrayHelper } from '../../../../../models/helpers/array-helper';
import { ModalDirective } from 'ngx-bootstrap';
import { MapLocation } from '../../../../core/components/map-picker/map-picker.component';
import { BaseComponent } from '../../../../core/components/bases/base-component';
import { UserService } from '../../../../core/services/user.service';
import { takeUntil } from 'rxjs/operators';
import { PlantingSiteService } from '../../../../core/services/planting-site.service';
import { ConfirmDeleteModalComponent } from '../../../../core/components/delete-modal/confirm-delete-modal-component';
import { PlantingSiteAreaDto } from '../../../../../models/trofaco/plantingSiteAreaDto';
import { ActivatedRoute, Router } from '@angular/router';
import { CanDeactivateService } from 'src/app/modules/core/services/can-deactivate.service';
import { IsInvalidDirective } from '../../../../core/directives/is-invalid.directive';
import { AppUserModel } from 'src/app/models/users/app-user.model';



@Component({
    selector: 'app-areas-entry',
    templateUrl: './areas-entry.component.html'
})
export class AreasEntryComponent extends BaseComponent implements OnInit {

    @ViewChild('fileInput', { static: true }) fileInput: ElementRef<HTMLInputElement>;
    @ViewChild(ConfirmDeleteModalComponent, { static: true }) confirmDelete: ConfirmDeleteModalComponent;

    @Input()
    plantingSiteId: string;
    @Input()
    siteAreas: PlantingSiteAreaDto[];

    selectedSiteArea: PlantingSiteAreaDto = {};

    files?: File[];
    years: number[];
    newAreaPhoto: File;
    @ViewChildren(IsInvalidDirective) isInvalidDirectives: IsInvalidDirective[];
    isKMLUpload: boolean;
    kmlFileName: string;
    isFlightPathUpload: boolean;
    flightPathName: string;
    uploadFlightPath: boolean;
    uploadKML: boolean;
    validKML: boolean;
    validFlightPath: boolean;
    formData: FormData = new FormData();
    isKmlFileDelete: boolean;
    isFlightPathFileDelte: boolean;
    currentUser: AppUserModel;

    constructor(
        private plantingSiteService: PlantingSiteService,
        private canDeactivateService: CanDeactivateService,
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService
        ) {
        super();
    }

    ngOnInit() {
        this.getCurrentUser();
        this.route.paramMap.subscribe(params => {
            let areaId = params.get('tabId');
            if (areaId != 'new') {
                this.selectedSiteArea = this.siteAreas.find(c => c.id == areaId);
                const valueSiteArea = this.selectedSiteArea;
                this.onCheckUrl(valueSiteArea);
            }
        });
        // this.wizardModal.onHidden.pipe(takeUntil(this.onDestroy$)).subscribe(() => this.files = undefined);
        // this.editModal.onHidden.pipe(takeUntil(this.onDestroy$)).subscribe(() => this.editPhoto = undefined);
        this.setupYears();
    }

    setupYears() {
        let firstYear = 2010;
        let yearToday = new Date().getFullYear();
        this.years = new Array(yearToday - firstYear + 2)
            .fill(0)
            .map((value, index) => index + firstYear).reverse();
    }

    validFileMimeTypes = ['image/jpeg', 'image/png'];

    filesSelected(fileList: FileList) {
        let files: File[] = [];
        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            if (this.validFileMimeTypes.includes(file.type))
                files.push(file);
        }
        if (files.length == 0) return;
        this.files = files;
        // this.wizardModal.show();
    }

    closeWizard() {
        this.fileInput.nativeElement.value = '';
        // this.wizardModal.hide();
    }

    showEditValidation = false;

    async save() {

        if (this.isInvalidDirectives.some(value => value.isInvalid)) return;

        if (this.selectedSiteArea.code === undefined)
            this.formData.append('code', '');
        if (this.selectedSiteArea.description === undefined)
        this.formData.append('description', '');

        if (this.selectedSiteArea.id) {
            this.formData.append('year', this.selectedSiteArea.year.toString());
            this.formData.append('id', this.selectedSiteArea.id);
            this.formData.append('name', this.selectedSiteArea.name);
            this.formData.append('code', this.selectedSiteArea.code);
            this.formData.append('description', this.selectedSiteArea.description);
            let result = await this.plantingSiteService.updatePlantingSiteArea(this.formData);
            this.selectedSiteArea.kmlUrl = this.isKmlFileDelete ? undefined : result.kmlUrl;
            this.selectedSiteArea.flightPathUrl = this.isFlightPathFileDelte ? undefined : result.flightPathUrl;
            this.selectedSiteArea.kmlAreaProperties = this.isKmlFileDelete ? null : result.kmlAreaProperties;

        }
        else {
            this.formData.append('plantingSiteId', this.plantingSiteId);
            this.formData.append('name', this.selectedSiteArea.name);
            this.formData.append('code', this.selectedSiteArea.code);
            this.formData.append('description', this.selectedSiteArea.description);
            this.formData.append('year', this.selectedSiteArea.year.toString());
            let result = await this.plantingSiteService.addPlantingSiteArea(this.formData);
            this.selectedSiteArea.id = result.id;
            this.selectedSiteArea.code = result.code;
            this.selectedSiteArea.kmlUrl = this.isKmlFileDelete ? undefined : result.kmlUrl;
            this.selectedSiteArea.flightPathUrl = this.isFlightPathFileDelte ? undefined : result.flightPathUrl;
            this.selectedSiteArea.kmlAreaProperties = this.isKmlFileDelete ? null : result.kmlAreaProperties;
            this.selectedSiteArea.videos = [];
            this.selectedSiteArea.collections = [];
            this.selectedSiteArea.species = [];
            this.siteAreas.push(this.selectedSiteArea);

        }
        if(this.newAreaPhoto){
            var result = await this.plantingSiteService.updatePlantingSiteAreaPhoto(this.newAreaPhoto, this.selectedSiteArea.id);
            this.selectedSiteArea.photo = result.data;
        }
        this.router.navigate(['/admin', 'plantingSites', this.plantingSiteId, 'plantings'], { replaceUrl: true });
    }

    onFileKMLUpload(event) {
        if (event.target.files && event.target.files.length) {
            this.kmlFileName = event.target.files[0].name;
            const [fileKML] = event.target.files;
            this.isKMLUpload = true;
            this.validKML = true;
            this.isKmlFileDelete = false;
            if (this.formData.get('kmlFile') !== null || undefined) {
                this.formData.set('kmlFile', fileKML, this.kmlFileName);
                this.formData.set('isKmlDelete', `${this.isKmlFileDelete}`);
                this.selectedSiteArea.kmlUrl = this.kmlFileName;

            } else {
                this.formData.append('kmlFile', fileKML, this.kmlFileName);
            }
        }
    }
    onFileKMLDelete(event) {
        this.isKMLUpload = false;
        this.isKmlFileDelete = true;
        if (this.formData.get('isKmlDelete') !== null || undefined) {
            this.formData.set('isKmlDelete', `${this.isKmlFileDelete}`);
        } else {
            this.formData.append('isKmlDelete', `${this.isKmlFileDelete}`);
        }
    }
    async onClickKML(data: string) {
        const nameData = data.split("/");
        const iframe = document.createElement('a');
        iframe.setAttribute('target', '_blank');
        iframe.setAttribute('href', `${data}`);
        iframe.setAttribute('download', `${nameData[2]}`);
        document.body.appendChild(iframe);
        iframe.click();
        iframe.remove();
    }


    onFileFlightPathUpload(event) {
        if (event.target.files && event.target.files.length) {
            this.flightPathName = event.target.files[0].name;
            const [fileFlightPath] = event.target.files;
            this.isFlightPathUpload = true;
            this.validFlightPath = true;
            this.isFlightPathFileDelte = false;
            if (this.formData.get('flightPathFile') !== null || undefined) {
                this.formData.set('flightPathFile', fileFlightPath, this.flightPathName);
                this.formData.set('isFlightPathDelete', `${this.isFlightPathFileDelte}`);
                this.selectedSiteArea.flightPathUrl = this.flightPathName ;
            } else {
                this.formData.append('flightPathFile', fileFlightPath, this.flightPathName);
                this.formData.append('isFlightPathDelete', `${this.isFlightPathFileDelte}`);
            }

        }
    }

    onFileFligthPathDelete(event) {
        this.isFlightPathUpload = false;
        this.isFlightPathFileDelte = true;
        if (this.formData.get('isFlightPathDelete') !== null || undefined) {
            this.formData.set('isFlightPathDelete', `${this.isFlightPathFileDelte}`);
        } else {
            this.formData.append('isFlightPathDelete', `${this.isFlightPathFileDelte}`);
        }

    }
    onClickFlightPath(data: string) {
        const nameData = data.split("/");
        const iframe = document.createElement('a');
        iframe.setAttribute('target', '_blank');
        iframe.setAttribute('href', `${data}`);
        iframe.setAttribute('download', `${nameData[2]}`);
        document.body.appendChild(iframe);
        iframe.click();
        iframe.remove();
    }

    onCheckUrl(valueSiteArea: PlantingSiteAreaDto) {
        if (valueSiteArea.kmlUrl != null) {
            this.isKMLUpload = true;
            let fileKmlName = valueSiteArea.kmlUrl.split("/");
            this.kmlFileName = fileKmlName[fileKmlName.length - 1];
            this.uploadKML = true;
        } if (valueSiteArea.flightPathUrl != null) {
            this.isFlightPathUpload = true;
            let fileFlightPathName = valueSiteArea.flightPathUrl.split("/");
            this.flightPathName = fileFlightPathName[fileFlightPathName.length - 1];
            this.uploadFlightPath = true;
        }
    }

    onPhotoSelected(photo: File){
        this.newAreaPhoto = photo;
    }

    async getCurrentUser() {
        this.currentUser = await this.userService.getCurrentUserAsync();
    }
}
